<template>
	<div>
		<div class="row mb-8">
			<div class="col-lg-12">
				<div class="float-right">
					<router-link class="btn btn-secondary mr-2" :to="`/forms/list/?signer=${$UserSession.getValue('id')}`" v-if="canViewAllForms">{{$t("view-all")}}</router-link>
					<MenuModalBtn />
					<button class="btn btn-secondary ml-2" @click="$router.go()"><b-icon icon="arrow-clockwise"></b-icon></button>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-8">

				<FormsWidget list="requiringattention" limit="5" :header="$t('action-required')" class="mb-8"></FormsWidget>

				<FormsWidget list="completed" limit="5" :header="$t('recently-completed')" class="mb-8"></FormsWidget>

			</div>

			<div class="col-lg-4">

				<div class="list-group border-radius-2 no-border mb-8" v-if="!$UserSession.hasPriv('APP_ALLSTUDENTS') && this.$config.getValue('workbooks').length">
					<div class="list-group-item list-group-header">
						<h6 class="m-0 p-0">{{ $t('workbooks') }}</h6>
					</div>
					<router-link
						v-for="workbook in $config.getValue('workbooks')"
						:key="workbook.id"
						class="list-group-item"
						style="user-select: none; cursor: pointer;"
						:to="`/forms/workbook/${workbook.id}`"
					>
						{{ workbook.title }}
					</router-link>
				</div>

				<FormsWidget list="recent" limit="3" :header="$t('recently-created')" class="mb-8"></FormsWidget>

				<FormsWidget list="awaitingresponse" limit="10" :header="$t('awaiting-response')"></FormsWidget>

			</div>
		</div>

	</div>
</template>

<script>
import MenuModalBtn from "src/components/Workflows/MenuModalBtn.vue";
import FormsWidget from "src/components/widgets/FormsWidget"

export default {
	components: {
		MenuModalBtn,
		FormsWidget
	},
	computed: {
		canViewAllForms() {
			return this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS");
		}
	}
};
</script>
